import { render, staticRenderFns } from "./AnnualReviewsQueue.vue?vue&type=template&id=b0170528"
import script from "./AnnualReviewsQueue.vue?vue&type=script&lang=js"
export * from "./AnnualReviewsQueue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports